var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7313 22.1717C41.2296 14.553 34.5383 8.83337 26.5 8.83337C20.1179 8.83337 14.575 12.455 11.8146 17.755C5.1675 18.4617 0 24.093 0 30.9167C0 38.2263 5.94042 44.1667 13.25 44.1667H41.9583C48.0533 44.1667 53 39.22 53 33.125C53 27.295 48.4729 22.5692 42.7313 22.1717ZM41.9583 39.75H13.25C8.36958 39.75 4.41667 35.7971 4.41667 30.9167C4.41667 26.3896 7.79542 22.6134 12.2783 22.1496L14.6412 21.9067L15.7454 19.8088C17.8433 15.7675 21.9508 13.25 26.5 13.25C32.2858 13.25 37.2767 17.3575 38.4029 23.033L39.0654 26.3455L42.4442 26.5884C45.8892 26.8092 48.5833 29.7021 48.5833 33.125C48.5833 36.7688 45.6021 39.75 41.9583 39.75ZM17.6667 28.7084H23.2979V35.3334H29.7021V28.7084H35.3333L26.5 19.875L17.6667 28.7084Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 53,
    y1: 18.56,
    x2: 0.0974772,
    y2: 22.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5134B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F34D21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c28191ddc47500926ed77a14aef10a13.svg";
export { ForwardRef as ReactComponent };